const WMS_SCAN = new Audio('assets/iupics/sounds/wms_scan.mp3');
const WMS_ERROR = new Audio('assets/iupics/sounds/wms_error.mp3');

function playScan(): void {
  WMS_SCAN.play();
}

function playError(): void {
  WMS_ERROR.play();
}

export const Sound = {
  playScan,
  playError,
};
